<form [formGroup]="quoteVehicleForm">
  <h3 class="font-weight-bold" dsContent [contentPath]="'policy.quoteVehicleDetailsHeader'"></h3>

  <div class="row margin-top-10">
    <div class="column twelve md-six">
      <div class="flex-column">
        <ds-form-control-container
          [labelText]="'Vehicle Year'"
          [control]="quoteVehicleForm.controls['year']"
          class="margin-top-10 column six"
        >
          <select
            id="year"
            class="icon fill"
            formControlName="year"
            data-cy="replaceVehicleYearSelect"
            (change)="getVehicleMake()"
          >
            <option value="unset" selected disabled>Select a Vehicle Year</option>
            @for (year of years$ | async; track year) {
              <option [value]="year">{{ year }}</option>
            }
          </select>
          <span class="icon-chevron-down"></span>
        </ds-form-control-container>
        @if (quoteVehicleForm.get('year').errors?.error) {
          <div class="error-600-text validation-error">
            {{ quoteVehicleForm.get('year').errors?.error }}
          </div>
        }
      </div>
      <ds-form-control-container
        [labelText]="'Vehicle Make'"
        [control]="quoteVehicleForm.controls['make']"
        class="margin-top-10"
      >
        <select
          id="make"
          class="icon fill"
          formControlName="make"
          data-cy="replaceVehicleMakeSelect"
          (change)="getVehicleModel()"
        >
          <option value="unset" selected disabled>Select a Vehicle Make</option>
          @for (make of vehicleMakes$ | async; track make) {
            <option [value]="make">{{ make }}</option>
          }
        </select>
        <span class="icon-chevron-down"></span>
      </ds-form-control-container>
      <ds-form-control-container
        [labelText]="'Vehicle Model'"
        [control]="quoteVehicleForm.controls['model']"
        class="margin-top-10"
      >
        <select
          id="model"
          class="icon fill"
          formControlName="model"
          data-cy="replaceVehicleModelSelect"
          (change)="getVehicleSeries()"
        >
          <option value="unset" selected disabled>Select a Vehicle Model</option>
          @for (model of vehicleModels$ | async; track model) {
            <option [value]="model">{{ model }}</option>
          }
        </select>
        <span class="icon-chevron-down"></span>
      </ds-form-control-container>
      @if (vehicleSeries$ | async; as vehicleSeries) {
        @if (vehicleSeries?.length) {
          <ds-form-control-container
            [labelText]="'Vehicle Series'"
            [control]="quoteVehicleForm.controls['series']"
            class="margin-top-10"
          >
            <select
              id="series"
              class="icon fill"
              formControlName="series"
              data-cy="replaceVehicleSeriesSelect"
              (change)="onSeriesSelected()"
            >
              <option value="unset" selected disabled>Select a Vehicle Series</option>
              @for (series of vehicleSeries; track series) {
                <option [value]="series">{{ series }}</option>
              }
            </select>
            <span class="icon-chevron-down"></span>
          </ds-form-control-container>
        }
      }
    </div>
  </div>
</form>
